export const USERS_LIST = "USERS_LIST";
export const USERS_CREATE = "USERS_CREATE";
export const USERS_UPDATE = "USERS_UPDATE";
export const USERS_DELETE = "USERS_DELETE";
export const USERS_SHOW = "USERS_SHOW";
export const USERS_ROLES_LIST = "USERS_ROLES_LIST";
